const scriptPromiseBySrc = new Map();

export const loadExternalScript = ({ src, id, attributes = {} }) => {
  if (!src) return Promise.reject(new Error('Script src is required'));

  if (scriptPromiseBySrc.has(src)) {
    return scriptPromiseBySrc.get(src);
  }

  const existingScript = document.querySelector(`script[src="${src}"]`);
  if (existingScript) {
    const resolved = Promise.resolve(existingScript);
    scriptPromiseBySrc.set(src, resolved);
    return resolved;
  }

  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    if (id) {
      script.id = id;
    }

    Object.keys(attributes).forEach((key) => {
      script.setAttribute(key, attributes[key]);
    });

    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

    document.body.appendChild(script);
  });

  scriptPromiseBySrc.set(src, promise);
  return promise;
};
